import { gql } from "@outschool/ui-apollo";

export const CategoryPageQuery = gql`
  query CategoryPage($slug: String!) {
    categoryPage(slug: $slug) {
      uid
      nameTitleCased
      nameSentenceCased
      reviewTitle
      reviewTitleWithPhotos
      slug
      basePath
      title
      description
      searchFilters {
        adminTags
        age
        capacityMax
        capacityMin
        delivery
        dow
        enabledBooleanFilters
        endBy
        endByTime
        format
        fundingPrograms
        hasFilledOutUniqueLearningNeeds
        languageOfInstruction
        multiTermQuery
        order
        pricePerMeetingMax
        pricePerMeetingMin
        q
        startAfter
        startAfterTime
        startBefore
        theme
        time
        timeOfDay
        timeZone
        uniqueLearningNeeds
        includedWithMembership
      }
      ancestors {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      related {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      parent {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      siblings {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      children {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      grandparent {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
      parentalSiblings {
        uid
        nameTitleCased
        nameSentenceCased
        slug
        basePath
      }
    }
  }
`;
